module.exports = __webpack_public_path__ + "static/media/raphael_gatchalian.1bca5b6e.png";